import React from "react";
import DOMPurify from "dompurify";

const Slide = ({
  slide,
  answer,
  updateAnswer,
  error,
  onCheckBoxChange,
  checkBoxes,
  inputErrors,
  questionFontSize,
  questionColor,
  answerFontSize,
  answerTextColor,
  answerBgColor,
  answerSelectedBgColor,
  answerSelectedTextColor,
  answerHoverBgColor,
  answerHoverTextColor,
  currentSlide,
  slides
}) => {
  const handleChange = (key, value) => {
    updateAnswer(key, value); // Update the specific field in the state
  };

  const qFont = questionFontSize || "28px";
  const qCol = questionColor || "#35265F";
  const ansFont = answerFontSize || "21px";
  const ansText = answerTextColor || "#35265F";
  const ansBg = answerBgColor || "#66D2F1";
  const ansSelBg = answerSelectedBgColor || "#66D2F1";
  const ansSelText = answerSelectedTextColor || "#35265F";
  const ansHoverBg = answerHoverBgColor || "#D5EDF2";
  const ansHoverText = answerHoverTextColor || "#35265F";

  if (window && window.Invoca) {
    window.Invoca.PNAPI.run();
  }

  return (
    <div className="slide-container">
      <h2
        className={slide.type === "multiple-fields" && "contact-heading"}
        style={{ fontSize: qFont, color: qCol }}
      >
        {slide.question}
      </h2>
      {slide.type === "multiple" ? (
        slide.Answers.map((a) => (
          <label
            key={a.option}
            className="non-contact-input"
            style={{
              display: "block",
              padding: "24px",
              margin: "8px 0",
              borderRadius: "99px",
              backgroundColor: answer === a.option ? ansSelBg : ansBg,
              borderColor: answer === a.option ? "#35265F" : "transparent",
              color: answer === a.option ? ansSelText : ansText,
              cursor: "pointer",
              fontSize: ansFont,
              "--hover-bg-color": ansHoverBg,
              "--hover-text-color": ansHoverText,
              textAlign: "center",
              fontWeight: "700",
            }}
          >
            <input
              required
              type="radio"
              name={slide.key}
              value={a.option}
              checked={answer === a.option}
              onChange={(e) => handleChange(slide.key, e.target.value)}
              onClick={() => {
                if (answer === a.option) {
                  handleChange(slide.key, a.option);
                }
              }}
              style={{ display: "none" }}
            />
            <span
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(a.option) }}
            />
          </label>
        ))
      ) : slide.type === "multiple-fields" ? (
        <>
          <div className="contact-fields-container">
            {slide.fields.map((field) => (
              <div key={field.key}>
                <label>
                  {field.type === "tel" ? (
                    <input
                      required
                      type="tel"
                      value={answer[field.key] || ""}
                      onChange={(e) => {
                        // Allow only numbers and format as "xxx-xxx-xxxx"
                        const rawValue = e.target.value.replace(/\D/g, ""); // Remove non-digits
                        let formattedValue = rawValue;
                        if (rawValue.length > 3 && rawValue.length <= 6) {
                          formattedValue = `${rawValue.slice(0, 3)}-${rawValue.slice(3)}`;
                        } else if (rawValue.length > 6) {
                          formattedValue = `${rawValue.slice(0, 3)}-${rawValue.slice(3, 6)}-${rawValue.slice(6, 10)}`;
                        }
                        handleChange(field.key, formattedValue);
                      }}
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "12px 16px",
                        // margin: "5px 0",
                        borderRadius: "4px",
                        border: "1px solid #58595B",
                      }}
                      placeholder={field.label}
                      maxLength="12"
                    />
                  ) : (
                    <input
                      required
                      type={field.type}
                      value={answer[field.key] || ""}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                      maxLength={field.key === "zip" ? "5" : undefined}
                      placeholder={field.label}
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "12px 16px",
                        // margin: "5px 0",
                        borderRadius: "4px",
                        border: "1px solid #58595B",
                      }}
                    />
                  )}
                  {inputErrors[field.key] && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {field.key === "email"
                        ? `Invalid e-mail address.`
                        : field.type === "tel" && (answer[field.key] || "").trim() !== ""
                        ? `Please enter a valid 10-digit phone number.`
                        : `${field.label} is required.`}
                    </span>
                  )}
                </label>
              </div>
            ))}
            {currentSlide === slides.length - 1 && slide.type === "multiple-fields" && (
              <div style={{ marginTop: "10px" }}>
                <label>
                  <input
                    type="checkbox"
                    checked={checkBoxes.first}
                    onChange={(e) => onCheckBoxChange("first", e.target.checked)}
                  />
                  I consent to receive marketing texts, including automated messages, from Medical Guardian at the number provided. This consent is not required to make a purchase. Messaging frequency may vary. Message and data rates may apply. Reply STOP to unsubscribe or HELP for help. I also agree to the following <a href="https://www.medicalguardian.com/legal/terms" target="_blank" >Terms</a> | <a href="https://www.medicalguardian.com/legal/privacy" target="_blank" >Privacy Policy</a>.
                </label>
              </div>
            )}
          </div>
        </>
      ) : (
        <input
          required
          type={slide.type === "number" ? "number" : "text"}
          value={answer || ""}
          onChange={(e) => handleChange(slide.key, e.target.value)}
          style={{
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            width: "100%",
          }}
        />
      )}
      {error && <p style={{ color: "red" }}>This field is required.</p>}
    </div>

  );
};

export default Slide;
